import * as React from "react";
import type { SVGProps } from "react";
const SvgMinimise02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3.56 13.49h6.951m0 0v6.951m0-6.951-8.11 8.11m18.04-11.09h-6.952m0 0V3.56m0 6.952 8.11-8.11"
    />
  </svg>
);
export default SvgMinimise02;
